const general = {
    'general': 'Allgemeines',
    'general.yes': 'Yes',
    'general.no': 'Nein',
    'general.ok': 'Okay',
    'general.cancel': 'Stornieren',
    'general.example': 'Beispeil',

    'general.date': 'Date',

    'general.active': 'Aktiv',
    'general.inactive': 'Inaktiv',

    'general.page_not_found': 'Seite nicht gefunden not',
    'general.no_results_found': 'keine Ergebnisse gefunden',

    'general.no_attentions': 'Keine Aufmerksamkeit erforderlich',

    'general.dashboard': 'Dashboard',
    'general.settings': 'die Einstellungen',

    'general.select_option': 'Entscheide dich',
    'general.select_all': 'Wählen Sie Alle',

    'general.name': 'Name',
    'general.description': 'Beschreibung',
    'general.email': 'E-mail address',
    'general.password': 'Kennwort',
    'general.password_confirm': 'Kennwort bestätigen',

    'general.reseller': 'Reseller',
    'general.resellers': 'Resellers',

    'general.client': 'Kunde',
    'general.clients': 'Kunden',

    'general.feed': 'Feed',
    'general.feeds': 'Feeds',

    'general.webshop': 'Webshop',
    'general.webshop_type': 'Webshop typ',
    'general.webshops': 'Webshops',

    'general.fields': 'Felder',
    'general.field': 'Feld',

    'general.connection': 'Verbindung',
    'general.connections': 'Verbindungen',

    'general.profile': 'Profile',
    'general.profiles': 'Profiles',

    'general.brands': 'Marken',
    'general.brand': 'Marke',

    'general.categories': 'Kategorien',
    'general.category': 'Kategorie',

    'general.attributes': 'Attributes',
    'general.attribute': 'Attribute',

    'general.prices': 'Preise',
    'general.price': 'Preis',

    'general.payment_interval': 'Pays per',

    'general.product_groups': 'Product groups',
    'general.product_group': 'Product group',

    'general.customer_groups': 'Customer groups',
    'general.customer_group': 'Customer group',

    'general.rule': 'Rule',

    'general.marge': 'Price margin ( percentage )',

    'general.company': 'Company',
    'general.company.name': 'Company name',
    'general.company.phone': 'Phone number',
    'general.company.website': 'Website',
    'general.company.iban': 'IBAN number',
    'general.company.chamber_of_commerce': 'CoC number',
    'general.company.vat_number': 'VAT number',
    'general.company.logo': 'Logo',

    'general.contact.name': 'Contact person',
    'general.contact.firstname': 'Vorname',
    'general.contact.middlename': 'Zweitname',
    'general.contact.lastname': 'Nachname',
    'general.contact.phone': 'Telefonnummer',
    'general.contact.email': 'E-mail',

    'general.address.street': 'Straße',
    'general.address.address': 'Straße und Hausnumme',
    'general.address.zipcode': 'Postleitzahl',
    'general.address.city': 'Stadt',
    'general.address.country': 'Land',
    'general.address.state': 'Provinz',

    'general.general_information': 'General information',
    'general.company_information': 'Company information',
    'general.contact_information': 'Contact information',
    'general.extra_information': 'Extra information',

    'general.invitation.invited': 'Invited',
    'general.invitation.send_to': 'Invitation sent to',

    'general.send_invitation': 'Send invitation',
    'general.send_invitation.sending': 'Sending invitation...',

    'general.resend_invitation': 'Resend invitation',
    'general.resend_invitation.explanation': 'Your invitation has been sent to %x. Enter a new email address to resend the invitation.',
    'general.resend_invitation.sending': 'Sending invitation...',
    'general.resend_invitation.other_email': 'Send invitation to another e-mail address',

    'general.save': 'Save',
    'general.save.saving': 'Saving...',

    'general.save_changes': 'Save changes',
    'general.save_changes.saving': 'Saving changes...',

    'general.goto.dashboard': 'Go to dashboard',

    'general.register': 'Registrieren',
    'general.register.step1': 'Register | My Company information',
    'general.register.step2': 'Register | My Contact information',
    'general.register.step3': 'Register | My Subscription plan',

    'general.current.customers': 'Derzeitige Kunden',
    'general.payment': 'Payment',
    'general.payments': 'Payments',

    'general.requests': 'Requests',

    'general.subscription.expired': 'Subscription expired',
    'general.subscription.false': 'Not subscribed',
    'general.admin': 'Admin',

    'general.status': 'Status',
    'general.exported': 'Exported',

    'general.location.type': 'Location type',
    'general.sync': 'Sync',

    'general.supported.software': 'Unterstützte Software',

    'general.subscription': 'Subscription',
    'general.subscription.type': 'Subscription type',
    'general.subscription.option': 'Subscription option',

    'general.faq': 'Häufig gestellte Fragen',
    'general.about': 'Über uns',
    'general.contact': 'Kontakt',
    'general.conditions': 'Terms and conditions',

    'general.languages': 'Sprachen',
    'general.language': 'Language',

    'general.file.choose': 'Datei wählen',
    'general.original': 'Original',
    'general.next_step': 'nächster Schrittt',
    'general.previous_step': 'vorheriger Schritt',

    'general.search': 'Wonach suchen Sie?',

    'general.dot': 'Dot (.)',
    'general.comma': 'Comma (,)',
    'general.dotcomma': 'Dotcomma (;)',
    'general.tab': 'Tab',
    'general.pipe': 'Pipe (|)',
    'general.double.quote': 'Double Quote (\"\)',
    'general.single.quote': 'Single Quote (\'\)',

    'general.alternative.categories': 'Alternatieve categorieen',

    'general.hour': 'Stunden',
    'general.day': 'Day(s)',
    'general.week': 'Week(s)',
    'general.month': 'Month(s)',
    'general.sync_interval': 'Sync changed interval',
    'general.update_interval': 'Sync update interval',
    'general.interval': 'Intervall',

    'general.profile.combine': 'Profil kombinieren',

    'general.profile.add': 'Profil hinzufügen',
    'general.profile.edit': 'Profil bearbeiten',

    'general.open': 'Open. After verifying your account you can log in. You can try again after loggin in into your account',
    'general.paid': 'Paid. After verifying your account you can log in',
    'general.failed': 'Failed. After verifying your account you can log in. You can try again after loggin in into your account',
    'general.expired': 'Expired. After verifying your account you can log in. You can try again after loggin in into your account',
    'general.canceled': 'Canceled. After verifying your account you can log in. You can try again after loggin in into your account',

    'general.user.open': 'Open. You can try again at the subscription page',
    'general.user.paid': 'Paid. Your subscription has been updated',
    'general.user.failed': 'Failed. You can try again at the subscription page',
    'general.user.expired': 'Expired. You can try again at the subscription page',
    'general.user.canceled': 'Canceled. You can try again at the subscription page',
    'general.none': 'None',

    'general.account.created': 'Account created. You can now login.',

    'general.switch': 'Switch',

    'general.switch.reseller': 'Client is now switched to the selected reseller.',

    'general.discount': 'Discount',
    'general.payment.yearly': 'I would like to pay yearly (20% discount)',
    'general.payment.monthly': 'I would like to pay monthly',

    'general.stacktrace': 'Stacktrace',
};

export default general;
